/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Apikeys_DescriptionInputs */

const en_settings_apikeys_description = /** @type {(inputs: Settings_Apikeys_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Manage your API keys for programmatic access`)
};

const zh_settings_apikeys_description = /** @type {(inputs: Settings_Apikeys_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`管理你的 API 密钥`)
};

/**
* | output |
* | --- |
* | "Manage your API keys for programmatic access" |
*
* @param {Settings_Apikeys_DescriptionInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const settings_apikeys_description = /** @type {((inputs?: Settings_Apikeys_DescriptionInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Apikeys_DescriptionInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_settings_apikeys_description(inputs)
	return zh_settings_apikeys_description(inputs)
});
export { settings_apikeys_description as "settings.apikeys.description" }